import {ReactNode} from "react";
import {PageMeta, usePageMeta} from "./usePageMeta";

// The page's h1, which also sets the browser tab's title, and whatever else search engines should know about the page.
export function PageHeader({title, children, ...meta}: { title: string, children?: ReactNode } & Omit<PageMeta, 'title'>) {
    usePageMeta({ title, ...meta });
    return (
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
            <h1 className="h3 mb-0">{title}</h1>
            {children && <div className="d-flex gap-2">{children}</div>}
        </div>
    );
}
